import React, { PureComponent } from 'react';
import styles from './style.less';
import { Result } from 'antd';

type Props = {
  className?: string;
  style?: React.CSSProperties;
  type: 'empty' | 'error' | 'info' | '404';
  text: string | React.ReactNode;
  subText?: string | React.ReactNode;
  direction?: 'vertical' | 'horizontal';
  gutter?: number;
};

const Images = {
  '404': require('./img/404.png'),
  empty: require('./img/empty.svg'),
  error: require('./img/error.svg'),
  info: require('./img/info.svg'),
};

/**
 * Exception (出错、空、普通提示)
 *
 */
export default class Exception extends PureComponent<Props> {
  static defaultProps = {
    className: '',

    style: {},

    gutter: 20,

    direction: 'vertical',
  };

  constructor(props) {
    super(props);
  }

  render() {
    let { style, type, text, gutter, direction, subText } = this.props;

    if (text === undefined) {
      if (type === 'empty') {
        text = '暂时没有查询到相关内容';
      } else if (type === 'error') {
        text = 'oops, 这里出现了一些错误';
      }
    }

    let typeImg = Images[type];

    let gutterStyle: React.CSSProperties =
      direction === 'vertical'
        ? {
            width: '100%',
            height: gutter,
          }
        : {
            width: gutter,
            height: '100%',
          };

    if (type === 'empty') {
      return <Result status="404" title={text} subTitle={subText} />;
    }

    return (
      <div
        className={`${styles.container} ${direction === 'vertical' ? styles.vertical : ''} `}
        style={Object.assign({ padding: '8% 0' }, style)}>
        <img src={typeImg} className={styles.img} draggable={false} alt={type} />
        <div style={gutterStyle} />
        <div className={`${styles.text}`}>{text}</div>
        {subText ? <div>{subText}</div> : null}
      </div>
    );
  }
}
